import React from 'react';
import { motion } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { Button } from '../ui/Button';
import { ChevronRightIcon, ClockIcon, ShieldCheckIcon, SparklesIcon } from 'lucide-react';
export function Step1Welcome() {
  const {
    setCurrentStep
  } = useIntake();
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto" data-id="element-224">
      <div className="text-center mb-10" data-id="element-225">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-white shadow-lg border-4 border-white mb-6 overflow-hidden" data-id="element-226">
          <img src="https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png" alt="Norden" className="w-full h-full object-cover" data-id="element-227" />
        </div>
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3 tracking-tight" data-id="element-228">
          Welkom bij uw project intake
        </h1>
        <p className="text-base text-gray-500 max-w-xl mx-auto leading-relaxed" data-id="element-229">
          Leuk dat u kiest voor Noord Digital! Om uw nieuwe website perfect aan
          te laten sluiten bij uw wensen, hebben we wat informatie nodig.
        </p>
      </div>

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 md:p-10 mb-8" data-id="element-230">
        <h2 className="text-lg font-bold text-gray-900 mb-6" data-id="element-231">
          Wat kunt u verwachten?
        </h2>

        <div className="grid gap-4 md:grid-cols-3 mb-8" data-id="element-232">
          <div className="flex flex-col items-center text-center p-5 rounded-2xl bg-[#F7F8FA]" data-id="element-233">
            <div className="w-10 h-10 rounded-full bg-[#E6F2FF] text-[#007AFF] flex items-center justify-center mb-3" data-id="element-234">
              <ClockIcon className="w-5 h-5" data-id="element-235" />
            </div>
            <h3 className="font-semibold text-gray-900 text-sm mb-1" data-id="element-236">
              ± 15 minuten
            </h3>
            <p className="text-xs text-gray-500 leading-relaxed" data-id="element-237">
              Neem even de tijd. U kunt altijd later informatie nasturen.
            </p>
          </div>

          <div className="flex flex-col items-center text-center p-5 rounded-2xl bg-[#F7F8FA]" data-id="element-238">
            <div className="w-10 h-10 rounded-full bg-[#E6F2FF] text-[#007AFF] flex items-center justify-center mb-3" data-id="element-239">
              <SparklesIcon className="w-5 h-5" data-id="element-240" />
            </div>
            <h3 className="font-semibold text-gray-900 text-sm mb-1" data-id="element-241">
              Alles op één plek
            </h3>
            <p className="text-xs text-gray-500 leading-relaxed" data-id="element-242">
              Van bedrijfsgegevens tot design wensen en functionaliteiten.
            </p>
          </div>

          <div className="flex flex-col items-center text-center p-5 rounded-2xl bg-[#F7F8FA]" data-id="element-243">
            <div className="w-10 h-10 rounded-full bg-[#E6F2FF] text-[#007AFF] flex items-center justify-center mb-3" data-id="element-244">
              <ShieldCheckIcon className="w-5 h-5" data-id="element-245" />
            </div>
            <h3 className="font-semibold text-gray-900 text-sm mb-1" data-id="element-246">
              Veilig opgeslagen
            </h3>
            <p className="text-xs text-gray-500 leading-relaxed" data-id="element-247">
              Uw gegevens worden vertrouwelijk en veilig verwerkt.
            </p>
          </div>
        </div>

        <div className="bg-amber-50 border-l-4 border-amber-400 p-4 rounded-r-xl mb-8" data-id="element-248">
          <p className="text-sm text-amber-800" data-id="element-249">
            <strong data-id="element-250">Tip van Norden:</strong> Heeft u bepaalde documenten of
            teksten nog niet? Geen probleem! U kunt in het formulier aangeven
            dat u deze later aanlevert.
          </p>
        </div>

        <Button size="lg" fullWidth onClick={() => setCurrentStep(2)} className="py-4" data-id="element-251">
          Start de intake
          <ChevronRightIcon className="w-5 h-5 ml-2" data-id="element-252" />
        </Button>
      </div>
    </motion.div>;
}